/** Shopify CDN: Minification failed

Line 80:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 81:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 94:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 104:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 108:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 123:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 137:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 158:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 158:36 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 67:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 68:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 81:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 91:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 95:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 110:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 124:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 145:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 145:36 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 54:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 55:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 68:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 78:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 82:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 97:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 111:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 132:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 132:36 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 41:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 42:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 55:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 65:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 69:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 84:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 98:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 119:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 119:36 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 28:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 29:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 42:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 52:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 56:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 71:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 85:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 106:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 106:36 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 15:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 16:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 29:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 39:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 43:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 58:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 72:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 93:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 93:36 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
